import apiKeysReducer from './slices/apiKeysDataSlice';
import authReducer from './slices/authSlice';
import businessInfoReducer from './slices/businessInfoDataSlice';
import createTripLogReducer from './slices/createTripLogSlice';
import dashboardStatsReducer from './slices/dashboardStatsSlice';
import deleteAccountReducer from './slices/deleteAccountSlice';
import driverTypeDistributionReducer from './slices/driverTypeDistributionStatus';
import getSettingsReducer from './slices/getSettingsSlice';
import hireDispatcherReducer from './slices/hireDispatcherSlice';
import incidentReportReducer from './slices/incidentReportSlice';
import kycInformationReducer from './slices/kycInformationSlice';
import kycStatusDataReducer from './slices/kycStatusSlice';
import lookupConfigReducer from './slices/lookupConfigDataSlice';
import lookupCountReducer from './slices/lookupCountSlice';
import paymentLinkReducer from './slices/paymentLinkSlice';
import signUpReducer from './slices/signUpSlice';
import triplogStatsReducer from './slices/triplogStatsSlice';
import vehicleCategoryReducer from './slices/vehicleCategorySlice';
import vehicleStatusReducer from './slices/vehicleStatusSlice';

export const reducers = {
  auth: authReducer,
  signUpData: signUpReducer,
  kycInformationData: kycInformationReducer,
  businessInfoData: businessInfoReducer,
  apiKeysData: apiKeysReducer,
  tripLogData: createTripLogReducer,
  deleteAccount: deleteAccountReducer,
  kycStatusData: kycStatusDataReducer,
  lookupCountData: lookupCountReducer,
  paymentData: paymentLinkReducer,
  lookupConfigData: lookupConfigReducer,
  hireDispatcher: hireDispatcherReducer,
  dashboardStatsData: dashboardStatsReducer,
  vehicleStatusData: vehicleStatusReducer,
  settingsData: getSettingsReducer,
  triplogStatsData: triplogStatsReducer,
  driverTypeDistributionData: driverTypeDistributionReducer,
  incidentReportData: incidentReportReducer,
  vehicleCategoryData: vehicleCategoryReducer,
};
